import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Entity } from '@app/shared/models/models.interface';
import { ContextMenuOption, ContextMenuOptionSelected, TemplateInfo } from '../../data-table.component';

@Component({
  selector: 'vfs-template-card',
  templateUrl: './template-card.component.html',
  styleUrls: ['./template-card.component.scss']
})
export class TemplateCardComponent implements OnInit {
  /** The template info */
  @Input() templateInfo: TemplateInfo;

  /** The click on card emitter */
  @Output() cardClicked = new EventEmitter<any>();

  /** The selected items */
  @Input() selection: SelectionModel<any> = null;

  /** context menu */
  @ViewChild(MatMenuTrigger, { static: true }) contextMenu: MatMenuTrigger;
  @Input() contextMenuOptions: Array<ContextMenuOption> = [];
  @Output() contextMenuOptionSelected = new EventEmitter<ContextMenuOptionSelected>();
  contextMenuPosition = { x: '0px', y: '0px' };

  /**
   * Constructor
   */
  constructor() {}

  /**
   * Initialize the component
   */
  ngOnInit() {}

  /**
   * Click on a card
   */
  cardClick() {
    this.cardClicked.emit(this.templateInfo.entity);
  }

  /**
   * Check if an item is selected
   *
   * @param item the item
   * @return true if so
   */
  isInSelection(item: Entity): boolean {
    return this.selection.isSelected(item);
  }

  hasContextMenu(): boolean {
    return !this.templateInfo.multiSelectActive && this.contextMenuOptions && this.contextMenuOptions.length > 0;
  }

  onContextMenu(mouseEvent: MouseEvent) {
    mouseEvent.preventDefault();
    mouseEvent.stopPropagation();

    this.contextMenuPosition.x = mouseEvent.clientX - 90 + 'px';
    this.contextMenuPosition.y = mouseEvent.clientY + 18 + 'px';
    this.contextMenu.menuData = { item: this.templateInfo.entity };
    this.contextMenu.openMenu();
  }

  onContextMenuAction(selectedOption: ContextMenuOption) {
    const value: ContextMenuOptionSelected = {
      option: selectedOption,
      entity: this.contextMenu.menuData.item
    };

    this.contextMenuOptionSelected.emit(value);
  }
}
